<template>
  <div id="app">
    <navbar></navbar>
    <router-view />
    <app-footer />
  </div>
</template>

<script>
import navbar from "./components/Navbar";
import AppFooter from "./components/AppFooter";

export default {
  components: {
    navbar,
    AppFooter,
  },
};
</script>
